import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import AppIcon from "@/components/AppIcon";
import Badge from "@/components/Badge";
import { Star } from "lucide-react";
import { track } from "@/lib/track";

export default function AppRow({ app, index = 0 }) {
  const navigate = useNavigate();
  const go = () => navigate(`/app/${app.id}`);
  return (
    <motion.div
      data-testid={`app-row-${app.id}`}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.04, 0.3) }}
      onClick={go}
      className="flex items-center gap-3 py-3 cursor-pointer active:opacity-70 transition"
    >
      <AppIcon src={app.icon} alt={app.name} size={60} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5 min-w-0">
          <span className="text-[15px] font-semibold leading-tight truncate">{app.name}</span>
          <Badge text={app.badge} />
        </div>
        <div className="text-xs text-slate-400 truncate">{app.subtitle || app.category}</div>
        <div className="mt-1 flex items-center gap-1 text-[11px] text-slate-400">
          <Star size={11} className="fill-amber-400 text-amber-400" />
          <span>{app.rating}</span>
          <span className="text-slate-600">· {app.ratings_count} оценок</span>
        </div>
      </div>
      <button
        data-testid={`app-download-button-${app.id}`}
        data-track-manual="true"
        onClick={(e) => {
          e.stopPropagation();
          track("download", "Скачать", {
            app_name: app.name || app.title || "",
            app_id: app.id,
          });
          go();
        }}
        className="shrink-0 px-5 py-1.5 rounded-full text-sm font-semibold bg-gradient-to-r from-blue-600 to-blue-500 text-white glow-blue active:scale-95 transition"
      >
        Скачать
      </button>
    </motion.div>
  );
}
